/**
 *  DateRange Interface
 *
 *  yyg 21.09.02
 */

export interface DateTermsItem {
  text?: string
  value?: number | string
}

export interface DateRange {
  startDate?: string
  endDate?: string
}
